var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"ws-progress-bar"},[_c('div',{staticClass:"ws-progress-bar__progress",style:({width:(_vm.percent + "%")})})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }